import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { HBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Dropdown } from '../../../../components/Dropdown';
import { addDocToMultiSelectedEntities } from '../../../Documents/actions';
import { toggleNotification } from '../../../Companies/actions';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_ADD_DOCUMENT } from '../../../Users/constants';
import { COLOR_BG_LIGHT } from '../../../../vars';
import { getOriginalFileNameOptions } from '../../../Documents/helpers';

const STATE = {
  download: true,
  isRequired: false,
  addDocument: false,
  addValue: '',
  deleteDocumentConfirm: null,
  documentDto: null,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  .req-field {
    color: red;
  }

  .search-top {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_BG_LIGHT};

    .list-result-label {
      font-weight: 500;
      width: 50px;
      margin: 5px;
      text-align: center;
      background-color: black;
      color: #fff;
    }
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class AddDocumentModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get entities() {
    const entities = this.props.vehicleIds?.map(id => ({
      entityId: id,
      entityType: 'vehicle',
    }));
    return entities;
  }

  addDocument() {
    if (!this.state.documentDto?.originalFilename) {
      return this.setState({ isRequired: true });
    }
    this.props.addDocumentForMultiselectedEntities(this.entities, this.state.documentDto, result => {
      if (result?.id) {
        this.props.toggleNotification('success');
        this.reset();
      }
    });
  }

  showModal(action) {
    this.props.sendAction(action);
  }

  onInputChange(evt) {
    const { name, value } = evt.target;
    this.setState((prev, props) => {
      return { ...prev, documentDto: { ...prev.documentDto, [name]: value } };
    });
    return this;
  }

  onDropDownChange(evt) {
    this.setState(prev => {
      return { ...prev, isRequired: false, documentDto: { ...prev.documentDto, originalFilename: evt.value } };
    });
  }

  onFileInputChange(evt) {
    const { name } = evt.target;
    const value = evt.target.files[0];
    this.setState((prev, props) => {
      return { ...prev, documentDto: { ...prev.documentDto, [name]: value } };
    });
    return this;
  }

  dropdown() {
    let vals = getOriginalFileNameOptions('vehicle');
    if (this.props.singleType) {
      vals = [this.props.singleType];
    }

    const options = _.orderBy(
      vals.map(val => ({
        label: this.lblStr(`vehicle.details.documents.fields.${val}`),
        value: val,
      })),
      val => val.label,
    );

    const value = options.find(o => o.value == this.state.documentDto?.originalFilename);

    return <Dropdown name="originalFilename" options={options} value={value} onChange={this.onDropDownChange.bind(this)} />;
  }

  reset() {
    this.props.sendAction('close');
  }

  render() {
    return (
      <Container>
        <HBox>
          {window.innerWidth <= 768 && (
            <HBox vCenter left className="search-top">
              <Left />
              {this.lbl('vehicle.overview.bulk_actions')}
              <p className="list-result-label">{this.props.vehicleIds?.length}</p>
            </HBox>
          )}
          <Modal  onClose={this.reset.bind(this)} title={this.lbl('vehicle.details.documents.modal.add')}>
            {this.lbl('vehicle.details.documents.modal.add')}
            <div>
              <div>{this.lbl('vehicle.details.documents.fields.originalFilename')}</div>
              {this.state.isRequired && (
                <p className="req-field">* {this.lbl(`vehicle.details.documents.modal.require_file_name`)}</p>
              )}
              <FormField>{this.dropdown()}</FormField>
            </div>
            <div>
              <div>{this.lbl('vehicle.details.documents.fields.description')}</div>
              <FormField>
                <Input name="description" onChange={this.onInputChange.bind(this)} />
              </FormField>
            </div>
            <div>
              <div>{this.lbl('vehicle.details.documents.fields.file')}</div>
              <FormField>
                <Input type="file" name="file" accept="*" onChange={this.onFileInputChange.bind(this)} />
              </FormField>
            </div>
            <ModalControls>
              <Button disabled={this.props.work} primary onClick={this.addDocument.bind(this)}>
              {this.lbl('invoice.create.createBtn')}
              </Button>
              <Button disabled={this.props.work} onClick={this.reset.bind(this)}>
                {this.lbl('cancel')}
              </Button>
            </ModalControls>
          </Modal>
        </HBox>
      </Container>
    );
  }
}

AddDocumentModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_ADD_DOCUMENT),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addDocumentForMultiselectedEntities(entities, documentDto, callback) {
      dispatch(addDocToMultiSelectedEntities(entities, documentDto, callback));
    },
    toggleNotification(message) {
      dispatch(toggleNotification('1', message));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddDocumentModal = compose(withConnect, withRouter, injectIntl)(AddDocumentModalComp);
